import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import { MY_FORMATS } from '../../../../modules/rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { userAlertsVMDigitalForms } from '../../entities/global/model';
import { FavouriteDialogService } from '../../favourite-dialog/favourite-dialog.service';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from '../../../../../app/shared/confirmation-box/confirmation-box.component';

@Component({
  selector: 'app-digital-form-user-alert',
  templateUrl: './digital-form-user-alert.component.html',
  styleUrls: ['./digital-form-user-alert.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})
export class DigitalFormUserAlertComponent implements OnInit {

  userAlertslist: userAlertsVMDigitalForms[]
  userAlertslist_: userAlertsVMDigitalForms[]

  checkedStatus: boolean = false
  status?: number
  showClearHistoryButton: boolean = false
  DashboardModuleFor: number;
  loader:boolean=false;
  constructor(public dialogRef: MatDialogRef<DigitalFormUserAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public _favouriteDialogService: FavouriteDialogService,
    private _router: Router,
    private _notify: NotificationsService,
    private readonly _pref: PreferencesService, public dialog: MatDialog,) { }

  ngOnInit() {
    this.DashboardModuleFor = this.data.ModuleId;
    this.getCurrentUserAlertsforDashbpard();
  }

  getCurrentUserAlertsforDashbpard() {
    this.loader=true;
    this._favouriteDialogService.getCurrentUserAlertsforDigitalForms(this.DashboardModuleFor).subscribe(res => {
      this.userAlertslist = res
      this.showClearHistoryButton = false
      this.loader=false;
    })
  }

  openNewWindow(Link) {
    this._pref.GetReplaceExistingTabStatus().subscribe(res => {
      if (res == "True") {
       window.open(Link, '_self');
      } else {
        window.open(Link, '_blank');
      }
    });
  }

  checkboxChanged(event, ID) {
    console.log(event.checked)
    if (event.checked == true) {
      this.status = 2
      this._favouriteDialogService.changeAlertStartusDigitalForms(ID, this.status).subscribe(res => {
        if (res == true) {
          this.getCurrentUserAlertsforDashbpard()
        }
      })
    }
    else if (event.checked == false) {
      this.status = 1
      this._favouriteDialogService.changeAlertStartusDigitalForms(ID, this.status).subscribe(res => {
        if (res == true) {
          this.getCurrentUserAlertsforDashbpard()
        }
      })
    }
  }

  ClearHistory() {
    this._favouriteDialogService.clearHistoryDigitalForms().subscribe(res => {
      if (res == true) {
        this._notify.success('Records have been successfully removed');
        this.getCurrentUserAlertsforDashbpard()
      }
    })

  }
  onCloseClick(): void {
    this.dialogRef.close();
  }

  selectAll: boolean = false;

  toggleSelectAll(event: any): void {

  const isChecked = event.checked;

  if (isChecked) {
  const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
    width: '400px',
    data: {
      title: 'Status',
      message: 'Are you sure you want to change the status for all alerts?'
    }
  });

  dialogRef.afterClosed().subscribe(result => {

    if (result?.confirmed) {

      this.userAlertslist.forEach((alert: any) => {

        if (alert.status === 1) {

          alert.isHistory = true;
        }
      });
        this.status = 2
        this._favouriteDialogService.ChangeAlertStatusBulk(this.DashboardModuleFor, this.status).subscribe(res => {
        if (res == true) {
          this._notify.success('Status for all alerts have been successfully updated');
          this.getCurrentUserAlertsforDashbpard()
        }
      })
    } else {
      // Revert select all checkbox if cancelled
      event.source.checked = false;
    }
  });
  }
}
}
